import createIcon from '../../createIcon';

/**
 * @component @name PermDeviceInformation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgN0gxMVY5SDEzVjdaTTEzIDExSDExVjE3SDEzVjExWk0xNyAxLjAxTDcgMUM1LjkgMSA1IDEuOSA1IDNWMjFDNSAyMi4xIDUuOSAyMyA3IDIzSDE3QzE4LjEgMjMgMTkgMjIuMSAxOSAyMVYzQzE5IDEuOSAxOC4xIDEuMDEgMTcgMS4wMVpNMTcgMTlIN1Y1SDE3VjE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PermDeviceInformation = createIcon('PermDeviceInformation', [
  [
    'path',
    {
      d: 'M13 7H11V9H13V7ZM13 11H11V17H13V11ZM17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19Z',
      key: '5x2gnt',
    },
  ],
]);

export default PermDeviceInformation;
